import "./ProfileMenu.css";
import React, { useState } from "react";
import { NavLink, useNavigate, useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { logoutUser } from "features/auth/authSlice";
import { openProfileMenu } from "features/menu/menuSlice";

import Swal from "sweetalert2";
import ProfileIcon from "assets/images/profile-icon.png";
import ProfileIconActive from "assets/images/profile-icon-o.png";
import TermsOfUse from "assets/documents/Terms of Use.pdf";
import useEffectHook from "utilities/hook/useEffectHook";

const ProfileMenu = () => {
  const { userInfo } = useSelector((state) => state.auth);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { pathname } = useLocation();
  const [isOpen, setIsOpen] = useState(false);

  const handleOpenMenu = () => {
    setIsOpen(!isOpen);
  };

  const handleLogOut = () => {
    setIsOpen(false);

    const swalFailedMessage = Swal.mixin({
      customClass: {
        popup: "swal-logout-popup",
        confirmButton: "swal-logout-confirm-btn",
        cancelButton: "swal-logout-cancel-btn",
        title: "swal-title",
      },
      buttonsStyling: false,
    });
    swalFailedMessage
      .fire({
        title: "Log Out",
        html: `<p class='swal-text-html'>Are you sure you want to log out?</p>`,
        imageWidth: 65,
        imageHeight: 60,
        confirmButtonText: "Yes, I'm Sure",
        cancelButtonText: "No, Go Back",
        reverseButtons: false,
        showCancelButton: true,
        allowOutsideClick: false,
      })
      .then(async (result) => {
        if (result.isConfirmed) {
          const payload = {
            user_uid: userInfo?.uid,
          };
          dispatch(logoutUser(payload)).then((result) => {
            if (result.payload.status === 1) {
              // show error message when logout is failed
              const swalFailedMessage = Swal.mixin({
                customClass: {
                  popup: "swal-failed-popup",
                  confirmButton: "swal-success",
                  title: "swal-title",
                },
                buttonsStyling: false,
              });
              swalFailedMessage.fire({
                title: "Sorry!",
                html: `<p class='swal-text-html'>${result.payload.error_message}</p>`,
                imageWidth: 65,
                imageHeight: 60,
                confirmButtonText: "Ok",
              });
            } else {
              // if logout success redirect to login page
              navigate("/login");
            }
          });
        }
      });
  };

  useEffectHook(() => {
    // if user token undefined then redirect to login page
    dispatch(openProfileMenu(isOpen));
  }, [isOpen], 0
);

  return (
    <div>
      <div className="dropdown-button" onClick={(e) => handleOpenMenu(e)}>
        <img
          src={
            pathname === "/my-profile" || pathname === "/change-password"
              ? ProfileIconActive
              : ProfileIcon
          }
          className="w-full h-full object-contain"
          alt=""
        />
      </div>
      {isOpen && (
        <div className="profile-menu-container">
          <div className="menu profile">
            <NavLink to="/my-profile">Profile</NavLink>
          </div>
          <div className="menu profile">
            <NavLink to="/change-password">Password</NavLink>
          </div>

          <div className="menu profile">
            <a
              href="https://www.termsfeed.com/live/3e5da10c-69d9-422d-8100-b7845547d340"
              target="_blank"
              rel="noopener noreferrer"
            >
              Privacy policy
            </a>
          </div>

          <div className="menu profile">
            <a href={TermsOfUse} target="_blank" rel="noopener noreferrer">
              Terms of Use
            </a>
          </div>

          <div className="menu logout" onClick={() => handleLogOut()}>
            Log Out
          </div>
        </div>
      )}
    </div>
  );
};

export default ProfileMenu;
